import React, { useState } from 'react'
import { Target, DollarSign, CreditCard, Receipt, Settings } from 'lucide-react'
import Targets from '../../../components/hr/payroll/Targets'
import EmployeeAllowances from '../../../components/hr/payroll/EmployeeAllowances'
import PrePayments from '../../../components/hr/payroll/PrePayments'
import Salary from '../../../components/hr/payroll/Salary'
import HRMSettings from '../../../components/hr/payroll/HRMSettings'
// import { usePermissions } from '../../../hooks/usePermissions'
import { PERMISSIONS } from '../../../config/roles'
// import AuthService from '../../../services/authService'

const PayrollManagement = () => {
  const [activeTab, setActiveTab] = useState('targets')
  
  // Get current user and permissions
  // const currentUser = AuthService.getCurrentUser()
  // const permissions = usePermissions(currentUser)

  const tabs = [
    {
      id: 'targets',
      label: 'Targets',
      icon: Target,
      component: Targets,
      requiredPermissions: [PERMISSIONS.HR.VIEW_TARGETS]
    },
    {
      id: 'employee-allowances',
      label: 'Employee Allowances',
      icon: DollarSign,
      component: EmployeeAllowances,
      requiredPermissions: [PERMISSIONS.HR.VIEW_ALLOWANCES]
    },
    {
      id: 'pre-payments',
      label: 'Pre-Payments',
      icon: CreditCard,
      component: PrePayments,
      requiredPermissions: [PERMISSIONS.HR.VIEW_PRE_PAYMENTS]
    },
    {
      id: 'salary',
      label: 'Salary',
      icon: Receipt,
      component: Salary,
      requiredPermissions: [PERMISSIONS.HR.VIEW_SALARY]
    },
    {
      id: 'hrm-settings',
      label: 'HRM Settings',
      icon: Settings,
      component: HRMSettings,
      requiredPermissions: [PERMISSIONS.HR.VIEW_HRM_SETTINGS]
    }
  ]

  // Filter tabs based on user permissions (for now, show all tabs)
  const availableTabs = tabs

  // Set default active tab to first available tab
  React.useEffect(() => {
    if (availableTabs.length > 0 && !availableTabs.find(tab => tab.id === activeTab)) {
      setActiveTab(availableTabs[0].id)
    }
  }, [availableTabs, activeTab])

  // Get active tab component
  const ActiveTabComponent = availableTabs.find(tab => tab.id === activeTab)?.component || (() => <div>No access</div>)

  if (availableTabs.length === 0) {
    return (
      <div className="p-6">
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <DollarSign className="h-5 w-5 text-yellow-400" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-800">
                Access Restricted
              </h3>
              <div className="mt-2 text-sm text-yellow-700">
                <p>You don't have permission to access Payroll Management features.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center">
              <DollarSign className="h-8 w-8 text-green-600 mr-3" />
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Payroll Management</h1>
            
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-8 overflow-x-auto">
            {availableTabs.map((tab) => {
              const Icon = tab.icon
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 whitespace-nowrap ${
                    activeTab === tab.id
                      ? 'border-green-500 text-green-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="w-5 h-5 mr-2" />
                  {tab.label}
                </button>
              )
            })}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ActiveTabComponent />
      </div>
    </div>
  )
}

export default PayrollManagement
